import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Core/i18n';

export const Home = () => {
    const { t } = useTranslation(); 

  return (
    <div className="text-center ">
        <h1>{t('welcome-text')}</h1>
        <NavLink to="/quiz" className="btn btn-primary mt-8"> 
           {t('start-button')}
        </NavLink>          
    </div>
  );
}

export default Home;
